// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"eE-z","smallCardRow":"fE-z","largeCardRow":"gE-z","productSearchRow":"hE-z","curatedRow":"iE-z"};